<template>
  <bj-modal
    v-if="visible"
    v-model="visible"
    class="inspection-timeline-modal"
    :title="`Condition Report #${inspection.id} Timeline`"
    position="right"
    :size="{ maxWidth:'60vw', minHeight:'100vh', minWidth:'40vw'}"
  >
    <div
      slot="content"
      class="content"
    >
      <div class="text-grey-7 mb-2">
        {{ capitalize(inspection.type.split('_').join(' ')) }} #{{ inspection.id }}
      </div>
      <div class="text-grey-7">
        {{ inspection.property.short_address }}
      </div>
      <bj-inner-loading
        label="Saving"
        :visible="loading"
      />
      <q-card-separator class="title-separator" />
      <q-timeline
        v-if="activities && activities.length !== 0"
        color="secondary"
        layout="dense"
        side="right"
        class="inspection-activities-timeline"
      >
        <q-timeline-entry
          v-for="(activity, activityIndex) in activities"
          :key="activity.id"
        >
          <inspection-timeline-activity
            :inspection="inspection"
            :activity="activity"
          />
          <SdDatetime
            slot="subtitle"
            :value="activity.created_at"
            :market-id="inspection.property.market_id"
            :timezone="inspection.property.timezone"
            class="q-timeline-subtitle"
          />
        </q-timeline-entry>
      </q-timeline>
    </div>
    <div
      slot="footer"
      class="row"
    >
      <q-input
        v-model="comment"
        class="col"
        :maxlength="2048"
        :minlength="2"
        type="textarea"
        float-label="Leave a comment..."
        :rows="2"
      />
      <q-btn
        class="col-2"
        :disable="loading || !comment"
        rounded
        color="primary"
        icon="save"
        size="md"
        outline
        label="Comment"
        no-caps
        @click.prevent="addComment"
      />
    </div>
  </bj-modal>
</template>

<script>
import InspectionTimelineActivity from './inspection-timeline-activity';

export default {
  components: { InspectionTimelineActivity },
  data() {
    return {
      visible: false,
      loading: false,
      inspection: {},
      activities: null,
      comment: '',
    };
  },
  methods: {
    async show(inspection) {
      this.activities = null;
      this.inspection = inspection;
      this.visible = true;
      this.loading = true;
      try {
        this.activities = await this.api().request('GET', `admin/inspections/${this.inspection.id}/activities`);
      } catch (error) {
        this.uiNotify(error.message || 'Error occurred while fetching inspection activities', 'negative');
      }
      this.loading = false;
    },
    async addComment() {
      if (!this.comment) {
        return;
      }
      try {
        const commentActivity = await this.api().request('POST', `admin/inspections/${this.inspection.id}/activities`, { comment: this.comment });
        this.activities.unshift(commentActivity);
        this.$emit('commented', { inspection: this.inspection, commentActivity });
        this.comment = '';
      } catch (error) {
        this.uiNotify(error.message || 'Error occurred while saving the comment', 'negative');
      }
    },
  },
};
</script>
<style lang="scss">
.inspection-timeline-modal {
  .content{
    font-size: 14px;
    strong {
      font-size: 14px;
    }
    .title-separator {
      margin: 1.5rem -1.5rem;
    }
    .inspection-activities-timeline {
      .q-timeline-entry {
        line-height: 1rem;
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        align-items: baseline;

        .q-timeline-subtitle {
          padding-left: 2rem;
          width: 175px;
        }
      }
    }
  }
}
</style>
